import { render, staticRenderFns } from "./PopupCategory.vue?vue&type=template&id=54900200&"
import script from "./PopupCategory.vue?vue&type=script&lang=js&"
export * from "./PopupCategory.vue?vue&type=script&lang=js&"
import style0 from "./PopupCategory.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports